var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8207 3.39961C17.8207 3.39961 17.6449 2.15859 17.1035 1.61367C16.418 0.896484 15.6516 0.892969 15.3 0.850781C12.7828 0.667969 9.00352 0.667969 9.00352 0.667969H8.99648C8.99648 0.667969 5.21719 0.667969 2.7 0.850781C2.34844 0.892969 1.58203 0.896484 0.896484 1.61367C0.355078 2.15859 0.182812 3.39961 0.182812 3.39961C0.182812 3.39961 0 4.85859 0 6.31406V7.67812C0 9.13359 0.179297 10.5926 0.179297 10.5926C0.179297 10.5926 0.355078 11.8336 0.892969 12.3785C1.57852 13.0957 2.47852 13.0711 2.8793 13.1484C4.3207 13.2855 9 13.3277 9 13.3277C9 13.3277 12.7828 13.3207 15.3 13.1414C15.6516 13.0992 16.418 13.0957 17.1035 12.3785C17.6449 11.8336 17.8207 10.5926 17.8207 10.5926C17.8207 10.5926 18 9.13711 18 7.67812V6.31406C18 4.85859 17.8207 3.39961 17.8207 3.39961ZM7.14023 9.33398V4.275L12.0023 6.81328L7.14023 9.33398Z",
    fill: "url(#paint0_linear_12169_814)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12169_814",
    x1: 1.16471,
    y1: 0.667969,
    x2: 14.7983,
    y2: 21.6976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#9360A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46B7E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeGradient);
export default __webpack_public_path__ + "static/media/youtubeGradient.c6180fc5d7daa6918af55372912c7916.svg";
export { ForwardRef as ReactComponent };